import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StockStatus } from '@models/api-search.models';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-stock-message',
    templateUrl: './stock-message.component.html',
    styleUrls: ['./stock-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, TranslateSafePipe]
})
export class StockMessageComponent {
    @Input() status: StockStatus = 'InStock';
    @Input() place: 'store' | 'online' = 'store';
}
